module.exports = __webpack_public_path__ + "img/ali-al-saady.100dedc2.jpg";